<template lang="html">
  <div class="app">
    <session ref="session"></session>
    <tracker ref="tracker"></tracker>

    <modal-component @action="handleModalAction" @close="modal = null" @changeModal="modal = $event" :modal="modal" />
    <navigation v-show="includeNav.includes($route.path)" :user="user" @modal="modal = $event" @logout="user = null" />

    <main class="container">
      <router-view @changeModal="modal = $event" :user="user" @logout="user = null" />

      <subscription v-show="canSubscribe && !subscriptionComplete" ref="sub"></subscription>
    </main>
    <custom-footer @changeModal="modal = $event" />
  </div>
</template>

<script>
import { EventBus } from './EventBus';

export default {
  provide() {
    return {
      mediaBaseUrl: "/media/inpulse-template-ac-new-a/",
      contentUrl: "https://content.pulse-boost.com/",
    }
  },

  mounted() {
    document.documentElement.lang = this.$i18n.locale;

    if (this.$i18n.locale === 'ar') {
      document.documentElement.dir = 'rtl';
      document.body.classList.add('body_arabic');
    }
  },

  data () {
    return {
      subscriptionComplete: true,
      user: null,
      modal: null,
      includeNav: ["/"],

      canSubscribe: false,
      hasSubscriptions: false,
      sessionUrl: this.$parent.sessionUrl,
      showPageChoose: false,
    }
  },

  methods: {
    handleModalAction(data) {
      this.user = data;
      this.$router.push("/profile");
    },
    getQuizParams() {
      return 'noquiz=1'
    },
    updateOnboarding() {
      this.canSubscribe = true
      this.$refs.sub.init()
    },
    handlePageChoose(page) {
      this.subscriptionPage = page === 'Подписка';
      this.showPageChoose = false;
    },
    updateUserInfo(userInfo) {
      EventBus.$emit('update-user-info', userInfo)
    },
    showUserSubscriptions(subscriptions) {
      this.hasSubscriptions = true
    },
    showPreloader() {
      document.body.classList?.add('loading')
    },
    hidePreloader() {
      document.body.classList?.remove('loading')
    },
    downloadApp(link) {
      // Track start trial event
      this.$refs.tracker.report('start_trial')

      console.log('App donwload link:', link)
      const successPageURL = '/customer/download-app/'
      window.location.replace(`${successPageURL}${window.location.search}`)
    },
    redirectToDashboard() {
      this.$router.push("/profile");
    },
    showErrorMessage(message) {
      console.log('ShowError:', message)

      if (message) {
        // Hack to avoid blocking UI when using apple pay
        setTimeout(() => {
          alert(message)
        }, 200)
      }
    }
  },

  created() {
    EventBus.$on('show-preloader', this.showPreloader)
    EventBus.$on('hide-preloader', this.hidePreloader)
    EventBus.$on('download-app', this.downloadApp)
    EventBus.$on('redirect-to-dashboard', this.redirectToDashboard)
    EventBus.$on('show-error', this.showErrorMessage)
  },

  destroyed() {
    EventBus.$off('show-preloader', this.showPreloader)
    EventBus.$off('hide-preloader', this.hidePreloader)
    EventBus.$off('download-app', this.downloadApp)
    EventBus.$off('redirect-to-dashboard', this.redirectToDashboard)
    EventBus.$off('show-error', this.showErrorMessage)
  },
}
</script>

<style lang="sass">
@import 'sass/layout.sass'
@import 'sass/preloader.sass'
@import 'sass/popup.sass'
@import 'sass/guaranteed-safe-checkouts.sass'
@import 'sass/form.sass'
@import 'sass/variables'
@import 'sass/reset'

body
  background: rgba(255, 255, 255, 1)
  font-size: 16px
  scroll-behavior: smooth

*
  box-sizing: border-box
  color: rgba(0, 0, 0, 1)
  font-optical-sizing: auto
  //font-family: "Poppins", sans-serif
  font-family: $fontSfProDisplay

img
  user-select: none

a
  text-decoration: none

h1, h2, h3, h6, p
  margin: 0
  font-family: $fontSfProDisplay
  //font-family: "Poppins", sans-serif
  font-optical-sizing: auto

.container
  min-height: 100lvh
  overflow: hidden

body.loading
  margin: 0
  background: #000

body.loading > *
  display: none

.loading
  &:before
    content: " "
    position: absolute
    left: calc(50% - 10px)
    top: calc(50% - 10px)
    animation: rotating 2.5s linear infinite
    border: 5px dotted #fff
    width: 20px
    height: 20px
    box-sizing: border-box

body.body_arabic
  .subscription_container
    .features__container,
    .reviews__container
      .feature,
      .review
        p
          text-align: right!important

    #credit-card-form
      span
        text-align: right

  .quiz-screen
    .quiz__header .step-back
      transform: rotate(180deg)

      @media screen and (min-width: $lg)
        left: unset
        right: 0
        transform: translateY(-50%) rotate(180deg)

    .options__wrapper
      .image_male
        left: -50px!important

    .option, .step__info
      .option__text, p
        text-align: right!important

  .static-content
    .static__first-screen
      overflow: hidden

    @media screen and (min-width: $lg)
      .features__container,
      .faq__container,
      .reviews__header
        h2,
        .faq__answer p
          text-align: right

    .feature__content
      h3, p
        text-align: right!important

    .controllers
      flex-direction: row-reverse

    .prev
      .arrow
        transform: rotate(180deg)

    .next
      .arrow
        transform: rotate(180deg)

  .quiz-screen .quiz__content .options__wrapper .image
    transform: scale(-1, 1)

body.loading:after
  content: var(--preloader)
  //content: 'Preparing account data. Please wait...'
  display: block
  color: #fff
  position: absolute
  margin: 0 auto
  width: fit-content
  top: calc(50% + 25px)
  left: calc(50% - 125px)
  width: 250px
  text-align: center
</style>
